module.exports = __webpack_public_path__ + "media/country_flags/ls-0836d3cf.png";